{
  "callback": {
    "authenticating": "Kuingia",
    "processing": {
      "auth": "Kuchakata uthibitishaji...",
      "exchanging_code": "Kubadilisha nambari ya ruhusa...",
      "success_redirect": "Mafanikio! Kuongoza kwenda dashibodi..."
    },
    "success": {
      "title": "Uthibitishaji Umefanikiwa"
    },
    "error": {
      "title": "Uthibitishaji Umeshindwa",
      "message": "Tumekutana na shida wakati wa kukuingia.",
      "try_again": "Jaribu Tena",
      "redirect_message": "Utaongozwa kwenda ukurasa wa nyumbani baada ya sekunde chache."
    },
    "info_message": "Tafadhali subiri tukikuingia kwa njia salama."
  },
  "logout": {
    "signing_out": "Kutoka",
    "signing_out_message": "Kufuta kikao chako...",
    "success_message": "Umetoka kwa mafanikio.",
    "logout_completed": "Kutoka kumekamilika.",
    "signed_out": "Umetoka",
    "redirect_message": "Utaongozwa kwenda ukurasa wa nyumbani hivi karibuni.",
    "go_home": "Nenda Ukurasa wa Nyumbani"
  }
}